import React from "react";
import "./onboardWelcomeTextLg.scss";
function OnboardWelcomeTextLg({ txt }) {
  return <span className="onboard-welcome-text-lg">{txt}</span>;
}

export default OnboardWelcomeTextLg;
